export default function (field, defaultValue) {
    let storedState = sessionStorage?.getItem(field);

    if (null === storedState) {
        return defaultValue;
    }

    return JSON.parse(storedState);
}
